import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, ViewEncapsulation } from '@angular/core';
import { CustomButtonModel } from '@fi-app/core/custom-button.model';
import { FiDialogsService } from '@fi-shared/fi-dialogs';
import { RoleCustomButtonEditDialogComponent } from './role-custom-button-edit-dialog/role-custom-button-edit-dialog.component';
import { RoleHelperService } from '../../../../services/role-helper.service';

@Component({
    selector: 'fi-role-custom-button',
    templateUrl: './role-custom-button.component.html',
    styleUrls: ['../role-application-setting/role-application-setting.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-role-custom-button' },
    standalone: false,
})
export class RoleCustomButtonComponent {
    @Input() customButton: CustomButtonModel;
    @Input() isEditMode: boolean;
    @Input() tooltipText: string;

    isEditIconVisible: boolean = false;
    readonly customButtonSelectedClassName: string = 'orange';
    readonly customButtonNotSelectedClassName: string = 'grey';

    constructor(
        private fiDialogsService: FiDialogsService,
        private cdr: ChangeDetectorRef,
        private roleHelperService: RoleHelperService,
    ) {}

    setEditIconVisibility(isVisible: boolean) {
        this.isEditIconVisible = isVisible;
    }

    getCustomButtonCardBorderColorClass(customButton: CustomButtonModel): string {
        return customButton.IsSelected ? this.customButtonSelectedClassName : this.customButtonNotSelectedClassName;
    }

    openEditCustomButtonDialog() {
        if (!this.isEditMode) return;

        this.fiDialogsService
            .custom({
                contentComponentRef: RoleCustomButtonEditDialogComponent,
                contentComponentData: this.customButton,
            })
            .onYesButtonClick((result: boolean) => this.updateCustomButton(result));
    }

    private updateCustomButton(isSelected: boolean) {
        this.customButton.IsSelected = isSelected;
        this.roleHelperService.setRoleDataChanged(true);
        this.cdr.detectChanges();
    }
}
